import React, { useEffect, useMemo, useRef, useState } from 'react';
import { loadScript } from 'loder';
import useMount from '@src/utils/hooks/use-mount';
import generateUid from '@src/utils/generate-uid';
import cx from 'classnames';
import styles from './index.less';

/**
 * 适龄提示
 * @param gameName
 * @returns {JSX.Element}
 * @constructor
 */
const AgeAppropriateTips = ({ gameName }) => {
  const [isReady, setIsReady] = useState(false);
  const uid = useMemo(() => `tips-${generateUid()}`, []);
  const ref = useRef();

  useMount(() => {
    if (!window.youxifenji) {
      loadScript('//zhcdn01.xoyo.com/xassets/lib/youxifenji/0.0.x/youxifenji.es5.umd.js').then(() => {
        setIsReady(true);
      });
    } else {
      setIsReady(true);
    }
  });

  useEffect(
    () => {
      if (isReady) {
        window.youxifenji(gameName, document.querySelector(`.${uid}`));
      }
    },
    [isReady]
  );

  const style = {
    display: isReady ? 'block' : 'none'
  };

  return <div ref={ref} className={cx(styles.root, uid)} style={style} />;
};

export default AgeAppropriateTips;
